import React, { useEffect, useState } from 'react'

import CreatableSelect from 'react-select/creatable'

import styled from 'styled-components'
import getPerspective from '../../../../../api/getPerspectives'

const CLASS_PREFIX = `ListAsync--styledMulitSelectCreatable`
const DefaultValue = { value: 0, label: 'All perspectives' }

export default function SelectPerspectives({
    onChange,
    select,
    isClearable = false
}: {
    onChange: (id: number) => void
    select: number

    isClearable?: boolean
}) {
    const [options, setOptions] = useState<{ value: number; label: string }[]>([DefaultValue])
    const [loading, setStateLoading] = useState<boolean>(true)

    useEffect(() => {
        if (!loading) setStateLoading(true)

        getPerspective()
            .then(({ data = [] }) => data)
            .then(data => data.map(({ name, id }) => ({ label: name, value: id })))
            .then(perspectives => setOptions([...perspectives, DefaultValue]))
            .finally(() => setStateLoading(false))
    }, [])

    return (
        <div style={{ width: '100%' }}>
            <label>{'Perspective'}2</label>
            <div style={{ minWidth: '200px' }}>
                <StyledCreatable
                    isClearable={isClearable}
                    isLoading={loading}
                    onMenuOpen={() => []}
                    isDisabled={false}
                    value={options.find(({ value }) => value === select)}
                    onChange={event => {
                        const value = event?.value
                        if (!value) onChange(0)
                        else onChange(value)
                    }}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    placeholder="Perspectives"
                    maxMenuHeight={150}
                    stye={{
                        width: '300px'
                    }}
                    options={options}
                />
            </div>
        </div>
    )
}

const StyledCreatable = styled(CreatableSelect)`
    &:focus-within {
        border-width: 2px;
        border-color: ${({ theme }) => theme['blue-500']};
    }
    .${CLASS_PREFIX}__option {
        color: ${props => props.theme['blue-500']};
        &--is-selected {
            color: ${props => props.theme['gray-0']};
        }
    }
    [class$='-control'] {
        background-color: var(--gray-100);
    }

    [class$='-menu'] {
        background-color: var(--gray-0);
    }
    [class$='-singleValue'] {
        color: var(--gray-700);
    }
    [class$='-option'] {
        color: var(--gray-700);
        background-color: var(--gray-100);
    }

    .${CLASS_PREFIX}__control {
        border: none;
        background: ${({ theme }) => theme['gray-0']};
        height: 20px;
        max-height: 20px;
        overflow: auto;
        border-radius: 0px;

        &::-webkit-scrollbar {
            width: 14px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme['gray-600']};
            border-radius: 25px;
            border: 4px solid transparent;
            background-clip: padding-box;
        }
    }
    .${CLASS_PREFIX}__indicator-separator {
        display: none;
    }
    .${CLASS_PREFIX}__indicators {
        display: flex;
    }
`

export { SelectPerspectives }
